<div class="flex flex-col h-screen">

  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Relatórios</h1>
        <!-- <p class="text-sm text-gray-500">Gerencie seu catálogo de produtos</p> -->
      </div>
    </div>
  </div>


  <div class="flex-1 px-6 py-4 bg-gray-50 md:mb-32 ">
    <div class="p-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 bg-white shadow rounded">
  @for (reportCategory of categories; track $index) {
    <p-fieldset>
      <ng-template #header>
        <div class="flex items-center gap-10 px-2">
          <p-avatar image="imgs/sale-bag.svg" shape="square" size="xlarge" />
          <span class="font-bold text-xl">{{reportCategory.label}}</span>
        </div>
      </ng-template>
      <div class="flex mt-4 justify-center">
        <button (click)="goTo(reportCategory.url)" 
                class="bg-orange-500 rounded p-2 text-xl text-white hover:cursor-pointer m-0">
          Visualizar
        </button>
      </div>
    </p-fieldset>
  }
</div>
  </div>
</div>